import React from 'react';
import * as cls from './partners-reviews.module.css';
import { Typography } from '../../../ui/components/typography';
import { IMG_PATH } from '../../../constants';
import { CarouselHalf } from '../../../ui/components/carousel-half';
import { Section } from '../../../ui/components/section';

const items = [
  {
    imgTitle: (
      <Typography className={cls['img-title-with-hightlight']}>
        <strong>Voltaware</strong> Smart Bills part of MyUtilita
      </Typography>
    ),
    img: `${IMG_PATH}/utilities/reviews-utilita-app.png`,
    logo: `${IMG_PATH}/utilities/reviews-utilita-logo.svg`,
    title: 'Fighting Energy Poverty with Voltaware Smart Bills',
    text: (
      <blockquote>
        “The cheapest and greenest energy is the energy we do not use, based on
        that we have created My Energy, which gives households most detailed
        breakdown of their energy consumption insights available - for free.”
      </blockquote>
    ),
    author: 'George Walters, Home Energy Officer',
  },
  {
    img: `${IMG_PATH}/utilities/reviews-burgenland-energie-app.png`,
    logo: `${IMG_PATH}/utilities/reviews-burgenland-energie-logo.svg`,
    title: 'Generating new revenues & increasing market share',
    text: (
      <>
        <ul>
          <li>Targeting non-Burgenland customers</li>
          <li>Bundling Voltaware Insights with HEMs offerings</li>
        </ul>
        <blockquote>
          “Together with Voltaware, we are confident we can help our customers
          optimize their energy use and contribute to a greener, more efficient
          future.”
        </blockquote>
      </>
    ),
    author: 'Stephen Sharma, CEO',
  },
  {
    imgLogo: `${IMG_PATH}/utilities/reviews-onda-app-logo.svg`,
    img: `${IMG_PATH}/utilities/reviews-onda-app.png`,
    logo: `${IMG_PATH}/utilities/reviews-onda-logo.svg`,
    title: 'Differentiating ONDA in Sicily & Sardinia',
    text: (
      <>
        <ul>
          <li>
            Voltaware Energy Insights as part of ONDA's EFFI100 mobile app
          </li>
          <li>40,000 Real-Time Energy Insights and Monthly Smart</li>
          <li>Bills users in Sicily & Sardinia</li>
          <li>Churn rate decrease × 4</li>
        </ul>
        <blockquote>
          “We are delighted to extend Voltaware technology, which helped us to
          acquire customers cheaper and retain them longer.”
        </blockquote>
      </>
    ),
    author: 'Luigi Martines, CEO',
  },
];

export const PartnersReviews = () => {
  return (
    <Section className={cls.section} classNameRoot={cls['section-wrapper']}>
      <Typography tag="h2">What Our Partners Say</Typography>

      <CarouselHalf className={cls.carousel} defaultPerPage={false} perPage={1}>
        {items.map((item, index) => (
          <div className={cls.item} key={index}>
            <div className={cls.item__left}>
              {item.imgLogo && <img src={item.imgLogo} alt="" />}
              {item.imgTitle && item.imgTitle}
              <img src={item.img} className={cls['img-app']} alt="" />
            </div>

            <div className={cls.item__right}>
              <div>
                <img src={item.logo} alt="" />
                <Typography className={cls['item__right__title']}>
                  {item.title}
                </Typography>
              </div>
              {item.text}
              <Typography className={cls['item__right__author']}>
                {item.author}
                <img src={`${IMG_PATH}/utilities/ico-quote.svg`} alt="" />
              </Typography>
            </div>
          </div>
        ))}
      </CarouselHalf>
    </Section>
  );
};
